import { NavigationEnd, Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export class RouterExtService {
    constructor(router) {
        this.router = router;
        this.previousOrderOverview = '/orders';
        this.previousUrl = "";
        this.currentUrl = "";
        this.currentUrl = this.router.url;
        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (event.url == '/orders' || event.url == '/afas/list') {
                    this.previousOrderOverview = event.url;
                }
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
            }
            ;
        });
    }
    getPreviousUrl() {
        return this.previousUrl;
    }
    getPreviousOrderOverviewUrl() {
        return this.previousOrderOverview;
    }
}
RouterExtService.ngInjectableDef = i0.defineInjectable({ factory: function RouterExtService_Factory() { return new RouterExtService(i0.inject(i1.Router)); }, token: RouterExtService, providedIn: "root" });
